export default "__VITE_ASSET__84e5bb5e__"